'use client';

import Image from 'next/image';
import { motion } from 'motion/react';
import { MeshGradient } from './mesh-gradient';

const ease = [0.22, 1, 0.36, 1] as const;

export function BrandPanel() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, ease }}
      className="relative hidden lg:flex lg:w-[55%] flex-col justify-between overflow-hidden"
      style={{ backgroundColor: 'hsl(222 25% 14%)' }}
    >
      <MeshGradient />

      {/* Content layer */}
      <div className="relative z-10 flex flex-col justify-between h-full p-12 xl:p-16">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7, ease }}
        >
          <Image
            src="https://assets.getcreatr.com/uploads/1778677644595-4d8s0hnts6u-image.png"
            alt="Everspark"
            width={160}
            height={36}
            className="h-9 w-auto"
            priority
          />
        </motion.div>

        {/* Tagline */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8, ease }}
          className="flex-1 flex items-end pb-16"
        >
          <div>
            <p className="font-display italic text-[2.5rem] xl:text-[2.75rem] text-white/90 leading-[1.15] max-w-md">
              Every spark,
              <br />
              nurtured and managed.
            </p>
            <div className="mt-6 w-12 h-px bg-gradient-to-r from-[hsl(221_83%_53%)] to-transparent" />
          </div>
        </motion.div>

        {/* Feature indicators */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.7 }}
          className="flex items-center gap-6 text-[13px] text-white/35 font-sans font-bold"
        >
          <span className="flex items-center gap-2 font-bold">
            <span className="w-1 h-1 rounded-full bg-[hsl(221_83%_53%)]" />
            Pipeline
          </span>

          <span className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-[hsl(221_83%_53%)]" />
            Follow-ups
          </span>
          <span className="flex items-center gap-2">
            <span className="w-1 h-1 rounded-full bg-[hsl(221_83%_53%)]" />
            Scheduling
          </span>
        </motion.div>
      </div>
    </motion.div>
  );
}
